import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { OperationObserverService } from '@x/common/operation';
import { TAvailabilityStatus } from '@x/ecommerce-shop/app/core/availability/availability';
import {
  AddToCartService,
  TAddToTarget,
} from '@x/ecommerce-shop/app/core/order/services/add-to-cart.service';
import { ProductItemService } from '@x/ecommerce-shop/app/core/product/services/product-item.service';
import { IProductItem } from '@x/ecommerce-shop/app/core/product/types/product-item';
import { IShopProductItem } from '@x/ecommerce/shop-client';
import { Observable } from 'rxjs';

@Component({
  selector: 'x-product-list-item',
  templateUrl: './product-list-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: false,
  host: { class: 'x-product-list-item' },
})
export class ProductListItemComponent {
  productItem$: Observable<IProductItem>;

  @Input()
  ghostState = false;

  @Input() addToTarget: TAddToTarget = 'MiniCart';

  @Input() set product(product: IShopProductItem) {
    this.productItem$ = this.productListItemService.getView$(product, 160);
  }

  @Input() mediaSize: number = 170;

  addToCartControl$ = this.operationService.control(
    (args: {
      product: IShopProductItem;
      quantity: number;
      availabilityStatus?: TAvailabilityStatus;
    }) => {
      const { quantity, availabilityStatus, product } = args;
      return this.addToCartService.addProduct(product, {
        quantity,
        availabilityStatus,
        addToTarget: this.addToTarget,
      });
    },
  );

  constructor(
    private operationService: OperationObserverService,
    private productListItemService: ProductItemService,
    private addToCartService: AddToCartService,
  ) {}

  async addToCart(productItem: IProductItem, quantity = 1) {
    const {
      product,
      variantAvailability: { availabilityView },
    } = productItem;

    await this.addToCartControl$.activate({
      product,
      quantity,
      availabilityStatus: availabilityView?.status,
    });
  }
}
